import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate } from "react-redux-i18n";

import ComponentSelector from "../utils/components/ComponentSelector";
import ReportsBy from "./reports/ReportsBy";

import "../../styles/components/insights/Reports.scss";
import { ReactComponent as CarIcon } from "../../styles/images/car_icon.svg";
import { ReactComponent as StationIcon } from "../../styles/images/station_icon.svg";

class Reports extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      selectedTab: 0,
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  selectTab(_e, selectedTab) {
    this.safeSetState({ selectedTab });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="reports">
        <ComponentSelector
          tabs={[
            {
              title: (
                <div className="tab-title">
                  <CarIcon
                    fill={
                      (parseInt(this.state.selectedTab) === 0 &&
                        this.props.brand?.colors?.secondaryColor) ||
                      "#71778a"
                    }
                  />
                  <Translate value="reports_evs" />
                </div>
              ),
              component: (
                <ReportsBy
                  mode="evs"
                  myFleets={this.props.myFleets}
                  myGroups={this.props.myGroups}
                />
              ),
            },
            {
              title: (
                <div className="tab-title">
                  <StationIcon
                    fill={
                      (parseInt(this.state.selectedTab) === 1 &&
                        this.props.brand?.colors?.secondaryColor) ||
                      "#71778a"
                    }
                  />
                  <Translate value="reports_chargingStations" />
                </div>
              ),
              component: (
                <ReportsBy
                  mode="chargers"
                  myFleets={this.props.myFleets}
                  myGroups={this.props.myGroups}
                />
              ),
            },
          ]}
          updateSelectedTab={this.selectTab.bind(this)}
          renderTabs
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(Reports);
